import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ReadonlyHttpApiRepository } from '@softline/core';
import { SOFTLINE_API_SALES_DOCUMENT_META_CONFIGURATION } from '../sales.api';
import { SalesConfiguration } from '../types/sales-configuration';

/**
 * Loads the per-session sales editor configuration from
 * `GET /meta/configuration` (no params, no body). Returns the discount
 * conditions + decimal-digit settings the document editor renders from.
 */
@Injectable({ providedIn: 'root' })
export class SalesConfigurationRepository extends ReadonlyHttpApiRepository<
  SalesConfiguration,
  void
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_SALES_DOCUMENT_META_CONFIGURATION);
  }
}
